import { render, staticRenderFns } from "./StoreRoleAdd.vue?vue&type=template&id=5e2bd1cc&scoped=true&"
import script from "./StoreRoleAdd.vue?vue&type=script&lang=js&"
export * from "./StoreRoleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2bd1cc",
  null
  
)

export default component.exports